import React from 'react';
import BaseSimpleItemBrowserHeader from "../BaseSimplePage/BaseSimpleItemBrowserHeader";
import ItemBrowserHeaderSimpleSelect from "../../components/ItemBrowserHeaderSimpleSelect";
import {allSuggestArtistRoles} from "../../data/Enums";

const ArtistSuggestionsItemBrowserHeader = ({
                                             mainRoleId,
                                             setMainRoleId,
                                             ...restProps
                                         }) => {


    function renderExtraContent() {
        return (
            <div style={{marginTop: "10px", display: "flex", flexDirection: "column", gap: "10px"}}>
                <ItemBrowserHeaderSimpleSelect
                    label="Род деятельности"
                    options={mainRoleOptions}
                    value={mainRoleId}
                    setValue={setMainRoleId}
                />
            </div>
        );
    }

    return (
        <BaseSimpleItemBrowserHeader
            {...restProps}
            renderExtraContent={renderExtraContent}
        />
    );
};

const mainRoleOptions = [{id: 0, name: "(все)"}, ...allSuggestArtistRoles];

export default ArtistSuggestionsItemBrowserHeader;